import { render, staticRenderFns } from "./DatesForm.vue?vue&type=template&id=6b8de35a&"
import script from "./DatesForm.vue?vue&type=script&lang=js&"
export * from "./DatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports